import React, { useState } from 'react';
import TimesheetFAQAccordion from "../layout/components/Accordian.jsx";

const Pricing = () => {

    const [isActive, setISActive] = useState(true); 

    const compData = [
        {
            heading : "General",
            data : [
                ["Projects", "Unlimited", "Unlimited", "Unlimited"],
                ["Users", "3", "Unlimited", "Unlimited"],
                ["Time Events", "Unlimited", "Unlimited", "Unlimited"],
                ["Invoice", "5/Month", "10/Month", "Unlimited"],
                ["Chat/Discussion", false, true, true]
            ]
        },
        {
            heading : "Time Tracking",
            data : [
                ["Timer Tracker", true, true, true],
                ["Time Sheet", true, true, true],
                ["Time Sheet Dashboard", false, true, true],
                ["Clone-Time Sheet Page", false, true, true],
                ["Breaks", false, false, true],
                ["Time Import/Export", false, false, true],
                ["Project Team", true, true, true],
                ["Unlimited Time Tracking", true, true, true],
                ["Calender Time Tracking", false, true, true]
            ]
        },
        {
            heading : "Project Management",
            data : [
                ["Dashboard", true, true, true],
                ["Cost Rate", false, true, true],
                ["Bill Rate", true, true, true],
                ["Project Status", true, true, true],
                ["Import Project", false, true, true],
                ["Export Project", true, true, true],
                ["Client", false, true, true],
                ["Announcement", false, true, true]
            ]
        },
        {
            heading : "Invoice",
            data : [
                ["Send Quotes", false, true, true],
                ["Send Invoices", false, true, true],
                ["Expenses", false, true, true],
                ["Leave Management", false, false, true],
                ["Time Off/Holiday", false, true, true]
            ]
        },
        {
            heading : "Reports",
            data : [
                ["Branded Reports", false, false, true],
                ["Export Report", false, true, true],
                ["Time Sheet Reporting", true, true, true],
                ["Expenses", false, false, true],
                ["Leave", false, false, true]
            ]
        },
        {
            heading : "Support",
            data : [
                ["Onboarding & Training", false, false, false],
                ["In-App Support", true, true, true],
                ["Priority Support", false, false, true]
            ]
        },
        {
            heading : "Admin Page",
            data : [
                ["Holiday", false, true, true],
                ["Leave", false, true, true]
            ]
        }
    ];

  return (
    <div id='pricing-page-container'>
        <div id="pricing-page-header-sec">
            <h1>Flexible Pricing Plans Tailored for You</h1>
            <div id='pricing-btn-wrapper'>
                <button className={(isActive ? "active-btn" : "idle-btn")} onClick={() => setISActive(true)}>Monthly</button>
                <button className={(!isActive ? "active-btn" : "idle-btn")} onClick={() => setISActive(false)}>Yearly</button>
            </div>
            <div id='pricing-plan-container'>
                <Plan key="Starter Plan:" fontColor="#50A6A5" heading="Starter Plan:" price="$0.00 / month" data={ ["5 Active Projects", "Up to 7 Users", "Unlimited Time Tracking", "Time Management Tool", "Project Teams", "Comprehensive Dashboard", "Billable Rates", "Project Overview"]} ad="Free" />
                <Plan key="Business Plan:" fontColor="#FE8C2C" heading="Business Plan:" price={isActive ? "$6.00 / month" : "$4.49 / month"} data={ ["Everything  in Starter pack +", "Unlimited Projects", "Unlimited Users", "Unlimited Time Entries", "Invoicing (up to 10)", "Time Tracking Tool", "Timesheet Management", "Advanced Reports", "Expense Management", "Team Collaboration", "Invoice Management"]} ad="" />
                <Plan key="Premium Plan:" fontColor="#007474" heading="Premium Plan:" price={isActive ? "$20.00 / month" : "$9.49 / month"}  data={ ["Everything  in Business pack +", "Budget Planning", "Role-Based Access Control", "Data Export Capability", "Custom Workflow Creation"]} ad="Best Value"/>
            </div>
        </div>
        <img src='/svg/pricing-page-hero.svg' alt="hero" width="100%" />
        <div id="comp-wrapper">
            {
                compData.map( singleData => <PlanComparison key={singleData.heading} heading={singleData.heading} compData={singleData.data} />)
            }    
            <div id='faq-wrapper'>
                <p>Frequently Asked Questions</p>
                <TimesheetFAQAccordion/>
            </div>
        </div>
    </div>
  )
}

const Plan = ({fontColor, heading, price, data, ad}) => {
    return(
        <div style={{color : fontColor}} className="pricing-plan-wrapper">
            <div className='plan-wrapper-heading'>
                <h1 style={{borderBottomColor : fontColor}} className='plan-heading'>{heading}</h1>
                {
                    ad !== "" ? <div style={{backgroundColor : fontColor}} className='top-right-half-circle'> <p>{ad}</p> </div> : null
                }
            </div>
            <p style={{borderBottomColor : fontColor}} className='plan-price'>{price}</p>
            <ul>
            {
                data.map((service, index) => <li key={index}>{service}</li>)
            }
            </ul>
        </div>
    )
}

const PlanComparison = ({heading, compData}) => {

    return(
        <div className='plan-wrapper'>
            <h1 className='plan-comp-heading'>{heading}</h1>
            <table>
                <thead>
                    <tr>
                        <td></td><td></td><td></td><td></td>
                    </tr>
                    <tr>
                        <th>  </th>
                        <th className='cmn-plan-head plan-comp-body-starter'> <h3> Free </h3> </th>
                        <th className='cmn-plan-head plan-comp-body-business'> <h3> Basic </h3> </th>
                        <th className='cmn-plan-head plan-comp-body-enterprise'> <h3> Premium </h3> </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        compData.map((data, index) =>
                            <tr key={index}>
                                {
                                    data.map( (singleData, index) => <td key={index}> {(typeof(singleData) == "string")? singleData : singleData === true? <img src='/svg/true.svg' width="25px" height="25px" alt='true' /> : <img src='/svg/false.svg'  width="25px" height="25px" alt='cross' />} </td>)
                                }
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </div>
    )
}

export default Pricing;